

































































































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import DiscountDetailBase from "./DiscountDetailBase";

	@Component
	export default class DiscountDetail extends DiscountDetailBase {

	 	 	
		created() {
			this.returnRoute = "TenantpaidDetail";
            super.initializeRights('COR_Tenant_Update', 'COR_Tenant_Update', 'COR_Tenant_Update', 'COR_Tenant_Update');
			super.setMainDescription('discount.new', 'discount.detail');
            this.mainDataChanged = false;
            this.createdBase();
		}

        preventRefresh(event: any) {
            if (this.$store.state.askBeforeCancelEditing === true && this.formIsInEditMode && this.dataWasChanged()) {
                event.preventDefault(); event.returnValue = "";
            }
		}

        beforeMount() {
            window.addEventListener("beforeunload", this.preventRefresh);
        }

        beforeDestroy() {
            window.removeEventListener("beforeunload", this.preventRefresh);
            this.$store.commit("formIsInEditMode", false);
            this.$store.commit("mainDataChanged", false);
        }

		mounted() {
			super.mounted();
		};

		validate() {
			return this.validateBase();
		}

        isAmount(value: any) {
            this.isAmountBase(value);
        }

        isCorrectMinDate(value: any) {
            this.isCorrectMinDateBase(value);
        }

        isCorrectMaxDate(value: any) {
            this.isCorrectMaxDateBase(value);
        }

        save() {
            this.saveBase();
        }

      
	}
